import React, { Component } from "react";
import CookieService from "../../../shared/services/cookiesService";
import configuration from "./../../../config.json";

class ReportConstructorChartCheck extends Component {
  constructor(props) {
    super(props);
    const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
    const email = authData.email;

    const charReports = !!localStorage.getItem(configuration.charReports)
      ? JSON.parse(localStorage.getItem(configuration.charReports))
      : [];

    let charReport = charReports.filter((x) => {
      return x.email === email;
    })[0];

    if (charReport === undefined) {
      charReport = {
        email,
        id: null,
      };

      charReports.push(charReport);

      localStorage.setItem(configuration.charReports, JSON.stringify(charReports));
    }

    this.state = {
      charReport,
    };
  }

  onChange(e) {
    const { charReport } = this.state;
    const { customReport } = this.props;

    const charReports = !!localStorage.getItem(configuration.charReports)
      ? JSON.parse(localStorage.getItem(configuration.charReports))
      : [];

    charReports.forEach((item) => {
      if (charReport.email === item.email) {
        item.id = e.target.checked ? customReport.id : null;

        this.setState({ charReport: item });
      }
    });

    localStorage.setItem(configuration.charReports, JSON.stringify(charReports));
  }

  render() {
    const { customReport } = this.props;
    const { charReport } = this.state;

    if (customReport === null || customReport === undefined || customReport.buildType !== 2) {
      return null;
    }

    return (
      <div>
        <input
          type="checkbox"
          key={customReport.id + "" + charReport.id === customReport.id}
          checked={charReport.id === customReport.id}
          onChange={this.onChange.bind(this)}
        />
        <span>Использовать график при просмотре маршрута</span>
      </div>
    );
  }
}

export default React.memo(ReportConstructorChartCheck);
